import { useQuery } from '@tanstack/react-query'
import { Alert, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { InArrivo, TitoloPagina } from '../layout/Pagina'
import { elencaServizi } from '../gestione/gestione.api'
import { ETICHETTE_MODULI } from './ModuloDaAttivare'

const DATA = new Intl.DateTimeFormat('it-IT', { dateStyle: 'long' })

export function GestioneServizi() {
  const { data: servizi = [], error } = useQuery({ queryKey: ['servizi'], queryFn: elencaServizi })
  const oggi = new Date().toISOString().slice(0, 10)

  return (
    <Stack spacing={2.5}>
      <TitoloPagina titolo="Gestione servizi" sottotitolo="I moduli del tuo contratto. Un modulo non attivo resta visibile nel menu con l'invito ad attivarlo." />
      {error && <Alert severity="error">{error.message}</Alert>}
      <Paper variant="outlined">
        <TableContainer>
          <Table size="small" aria-label="Moduli del contratto">
            <TableHead>
              <TableRow>
                <TableCell>Modulo</TableCell>
                <TableCell>Stato</TableCell>
                <TableCell>Scadenza</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(ETICHETTE_MODULI).map(([chiave, nome]) => {
                const s = servizi.find((x) => x.chiave === chiave)
                const attivo = s !== undefined && s.scadeIl >= oggi
                return (
                  <TableRow key={chiave}>
                    <TableCell>{nome}</TableCell>
                    <TableCell>
                      <Chip size="small" color={attivo ? 'success' : 'default'} variant={attivo ? 'filled' : 'outlined'}
                        label={attivo ? 'Attivo' : s ? 'Scaduto' : 'Non attivo'} />
                    </TableCell>
                    <TableCell>{s ? DATA.format(new Date(s.scadeIl)) : '—'}</TableCell>
                    <TableCell align="right">{!attivo && <InArrivo etichetta="Attiva" />}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Stack>
  )
}
